export function applyActiveStatusFilter(sensors, { featureActive, activeStatusFilter }) {
  if (!featureActive) {
    return sensors;
  }
  if (activeStatusFilter === 'all') {
    return sensors;
  }
  return sensors.filter(sensor => sensor.status === activeStatusFilter);
}
